import React from 'react'
import styles from './styles.module.css'

const Row = ({ children }) => {
  const addClass = (child, firstColumn) => {
    const hasOverflow = child.type === 'table'
    return (
      <div
        className={`${
          firstColumn ? 'hot-col-xl-6' : 'hot-col-xl-offset-1 hot-col-xl-5'
        } ${hasOverflow && styles.overflowX}`}
        key={firstColumn ? '0' : '1'}
        data-testid={`row-${firstColumn ? 'first' : 'second'}-col`}
      >
        {child}
      </div>
    )
  }

  const renderChildren = () => {
    if (typeof children === 'object') {
      if (children.length > 1) {
        return filterChildren().map((child, index) => {
          return addClass(child, index === 0)
        })
      }
      return addClass(children, true)
    }
    return children
  }

  const filterChildren = () => {
    return children.filter(child => typeof child === 'object')
  }

  return <div className={`hot-row ${styles.container}`}>{renderChildren()}</div>
}

export default Row
